import React, { useContext, useEffect } from "react";
import { FormContext } from '../../Pages/Apply'

const  Stepper = (props) => {
  const { activeStepIndex } = useContext(FormContext);
  useEffect(() => {
    const stepperItems = document.querySelectorAll(".stepper-item");
    stepperItems.forEach((step, i) => {
      if (i  < activeStepIndex) {
        step.classList.add("finish");
      } 
      else if  (i  == activeStepIndex){
        step.classList.add("active");
      }
      else {
        step.classList.remove("active", "finish");
      }
    });
  }, [activeStepIndex]);
  return (

    <div class="form-header d-flex mb-4">
      <span class="stepper-item">Student</span>
      <span class="stepper-item">Eligibility</span>
      <span class="stepper-item">Documents</span>
      <span class="stepper-item">Confirmation</span>
    </div>    
  );
}

export default Stepper;